'use client'

import { useTranslations } from 'next-intl'
import type { ReactNode } from 'react'
import { useState } from 'react'

export default function StoryBlockToggle({
  children,
}: {
  children: ReactNode
}) {
  const t = useTranslations('common')
  const [expanded, setExpanded] = useState(false)

  return (
    <>
      {!expanded && (
        <div className="text-center">
          <button
            className="mb-10 mt-2 border border-black bg-white px-2 py-1 text-base text-black"
            onClick={() => setExpanded(!expanded)}
          >
            {t('readMore')}
          </button>
        </div>
      )}
      <div
        className={`overflow-hidden transition-all duration-1000 ease-in-out ${
          expanded ? 'opacity-100' : 'h-0 opacity-20'
        }`}
        style={{
          clipPath: expanded
            ? 'circle(150% at 50% 0%)'
            : 'circle(0% at 50% 0%)',
        }}
      >
        {children}
      </div>
    </>
  )
}
